import moment from "moment";

export const momentConfigLocale = () => {
  moment.locale("pt-BR");
};



// WEBPACK FOOTER //
// ./src/config/moment.js